<div class="add-product-container">
  <!-- Header con título y botón cerrar -->
  <div class="header-container">
    <ui-paragraph
      type="p16"
      mobile-type="p16"
      text-color="neutrals-900"
      font-weight="semibold"
    >
      Agregar producto
    </ui-paragraph>
    <button type="button" class="close-button" (click)="onCancelProduct()">
      <ui-icon name="close" fill="neutrals-700" m-size="24" size="24" />
    </button>
  </div>

  <!-- Grid de columnas por unidad de negocio -->
  <div class="columns-grid">
    <!-- Columna Concreto -->
    <div class="column-item">
      <div class="column-header">
        <ui-paragraph
          type="p14"
          mobile-type="p14"
          text-color="neutrals-700"
          font-weight="semibold"
        >
          Concreto
        </ui-paragraph>
      </div>
      <div class="column-content">
        <unicon-product-field
          [initialBusinessLineId]="CONCRETE_ID"
          [verticalContainer]="true"
          (result)="onProductAdded($event)"
          (cancel)="onCancelProduct()"
        />
      </div>
    </div>

    <!-- Columna Vigueta -->
    <div class="column-item">
      <div class="column-header">
        <ui-paragraph
          type="p14"
          mobile-type="p14"
          text-color="neutrals-700"
          font-weight="semibold"
        >
          Vigueta
        </ui-paragraph>
      </div>
      <div class="column-content">
        <unicon-product-field
          [initialBusinessLineId]="JOISTS_ID"
          [verticalContainer]="true"
          (result)="onProductAdded($event)"
          (cancel)="onCancelProduct()"
        />
      </div>
    </div>

    <!-- Columna Embolsado -->
    <div class="column-item">
      <div class="column-header">
        <ui-paragraph
          type="p14"
          mobile-type="p14"
          text-color="neutrals-700"
          font-weight="semibold"
        >
          Embolsado
        </ui-paragraph>
      </div>
      <div class="column-content">
        <unicon-product-field
          [initialBusinessLineId]="BAGGED_ID"
          [verticalContainer]="true"
          (result)="onProductAdded($event)"
          (cancel)="onCancelProduct()"
        />
      </div>
    </div>
  </div>
</div>
